import { useState, forwardRef } from 'react';
import { Input } from '@/components/ui/input';
import { Eye, EyeOff } from 'lucide-react';

/**
 * PasswordInput — Input field with an eye toggle to show/hide the password.
 * Props are passed straight through to the underlying <Input>; only `type` is managed.
 *
 * Usage:
 *   <PasswordInput value={pw} onChange={e => setPw(e.target.value)} data-testid="admin-password-input" />
 */
export const PasswordInput = forwardRef(function PasswordInput({ className = '', 'data-testid': testId, ...rest }, ref) {
    const [show, setShow] = useState(false);
    return (
        <div className='relative'>
            <Input
                ref={ref}
                type={show ? 'text' : 'password'}
                className={`pr-10 ${className}`}
                data-testid={testId}
                {...rest}
            />
            <button
                type='button'
                onClick={() => setShow(s => !s)}
                aria-label={show ? 'Hide password' : 'Show password'}
                title={show ? 'Hide password' : 'Show password'}
                className='absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 grid place-items-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted transition'
                data-testid={testId ? `${testId}-toggle` : 'password-toggle'}
            >
                {show ? <EyeOff className='w-4 h-4' /> : <Eye className='w-4 h-4' />}
            </button>
        </div>
    );
});

export default PasswordInput;
